import OverviewHeroImage from '@images/use-cases/UseCaseOverview.webp';
import type { StaticImageData } from 'next/image';

export type UseCasesOverviewHeroContent = {
    tag: string;
    title: string;
    /** Second line of the H1 (e.g. “for …”) shown below `title`. */
    titleLine2?: string;
    description: string;
    secondaryDescription?: string;
    image: StaticImageData | string;
    imageAlt: string;
};

export const USE_CASES_OVERVIEW_HERO: UseCasesOverviewHeroContent = {
    tag: 'Use Cases',
    title: 'Explore Use Cases',
    titleLine2: 'for Predictable Benefits',
    description:
        'Traditional group plans weren’t built for today’s workforce — or the partners who support it. As complexity grows, so does the need for more flexible, scalable solutions.',
    secondaryDescription:
        'ICHRA is reshaping how brokers, PEOs, FMOs, and TPAs operate — giving each role new ways to grow, adapt, and stay competitive.',
    image: OverviewHeroImage,
    imageAlt:
        'Professionals collaborating in a modern office, representing benefits and insurance partners.',
};
